import React, {useState} from 'react';
import TopBar from '../../Components/TopBar';
import Page from '../../Components/Containers/Page';
import Form, { Actions, Password, RequiredValidator, SwitchGroup, SwitchGroupValidator, TextArea } from '../../Components/Form';
import { useUser } from '../../Data/Users';
import Button from '../../Components/Button/Button';
import { useHelp } from '../../Components/Help';
import { useNavigate } from 'react-router-dom';
import ButtonRow from '../../Components/Button/ButtonRow';
import { useSession } from '../../Components/Session';
import { useNewWindow } from '../../Services/helpers';

const CloseAccount = () => {
    const {closeAccount} = useUser();
    const {openLiveChat} = useHelp();
    const navigate = useNavigate();
    const [startConfirming, setStartConfirming] = useState(false);
    const {logout} = useSession();
    const newWindow = useNewWindow();

    const handleSubmit = async (data) => {
        await closeAccount(data);
        await logout();
        window.location.reload();
    }

    return <>
        <TopBar left="BackBtn" title="Close Account" />

        <Page>

            <div className="prose">
                <p>We’re sorry to see you go. Is there something we can do to make things better?</p>
                <p>We value your experience with us and would love the chance to address any concerns or feedback. Our team is here to help - just let us know how we can assist.</p>

                <ButtonRow arrange="betweenAround">
                    <Button theme="primary" onClick={() => { navigate('/more', {replace: true}); openLiveChat()}} label="Chat" />
                    <Button theme="primary" onClick={() => newWindow('https://getsoapy.com/docs')} label="Search help" />
                    <Button theme="danger" onClick={() => setStartConfirming(true)} label="Close account" />
                </ButtonRow>
            </div>

            {startConfirming && <Form onSubmit={handleSubmit}>
                <p className="mt-5">
                    Closing account will delete ALL of your data.<br />
                    Please confirm you wish us to delete the following:
                </p>
                <SwitchGroup name="toggles"
                    label="Confirm"
                    switches={[
                        {label: 'Delete Customers', name: 'deleteCustomers'},
                        {label: 'Delete Payments', name: 'deletePayments'},
                        {label: 'Delete Work History', name: 'deleteWork'},
                        {label: 'Delete Website', name: 'deleteWebsite'},
                        {label: 'Delete Expenses', name: 'deleteExpenses'},
                    ]}
                    validators={[SwitchGroupValidator(
                        ['deleteCustomers', 'deletePayments', 'deleteWork', 'deleteWebsite', 'deleteExpenses'],
                        'Please confirm all options'
                    )]}
                />
                <TextArea name="reason" label="Why are you closing your account?" validators={[RequiredValidator]} />
                <Password name="password" label="Confirm your password" validators={[RequiredValidator]} />
                <Actions submit={{label: 'Close account'}} />
            </Form>}

        </Page>
    </>
}

export default CloseAccount;
